import * as Yup from 'yup';
import { locale } from '../../constants/locales';

export default Yup.object().shape({
    title: Yup.string().required(locale.Messages.REQUIRED_FIELD),
    projectType: Yup.string().required(locale.Messages.REQUIRED_FIELD),
});
